// TEMPORARY: remove after the mobile horizontal-overflow bug is fixed.
// Inert unless the URL contains ?debugoverflow. Re-scans continuously so it
// measures whatever screen is showing (including Home after client-side login).
export function runOverflowDiagnostic() {
  if (!/[?&]debugoverflow/.test(window.location.search)) return;

  const scan = () => {
    const doc = document.documentElement;
    const vw = doc.clientWidth;
    const offenders = [];
    document.querySelectorAll('*').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      const over = Math.max(r.right - vw, -r.left);
      if (over > 1) {
        el.style.outline = '2px solid red';
        offenders.push({ el, over: Math.round(over) });
      }
    });
    offenders.sort((a, b) => b.over - a.over);

    let banner = document.getElementById('__ovf');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = '__ovf';
      banner.style.cssText =
        'position:fixed;top:0;left:0;right:0;z-index:2147483647;background:#111;color:#0f0;' +
        'font:12px/1.4 monospace;padding:8px;white-space:pre-wrap;max-height:45vh;overflow:auto;' +
        'pointer-events:none';
      document.body.appendChild(banner);
    }
    banner.textContent =
      `PAN=${doc.scrollWidth > vw ? 'YES' : 'no'}  viewport=${vw}  scrollWidth=${doc.scrollWidth}\n` +
      `offenders (${offenders.length}):\n` +
      offenders.slice(0, 8).map(({ el, over }) =>
        `<${el.tagName.toLowerCase()}> +${over}px  ${(el.getAttribute('class') || '').slice(0, 70)}`
      ).join('\n');
  };

  const kick = () => setTimeout(scan, 300);
  window.addEventListener('load', kick);
  window.addEventListener('resize', kick);
  setInterval(scan, 1200); // re-scan so it catches Home after you log in
}
